import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Link from 'redux-first-router-link';

import { settings } from '../lib/settings';
import config from '../lib/config';

class SidebarView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toplevelOverride: '',
      secondlevelOverride: '',
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.toplevel !== this.props.toplevel) {
      this.setState({ toplevelOverride: '', secondlevel: '' }); // eslint-disable-line
    }
  }

  selectTopLevel(toplevelOverride) {
    this.props.toggleMenu(false);
    this.setState({ toplevelOverride });
  }

  selectSecondLevel() {

  }

  render() {
    const { menuClosed = false, payload } = this.props;
    const user = settings.get('user.roles');
    const userOrgRoles = user ? settings.get('user.roles')
      .filter(role => role.org_id === payload.orgId)
      .map(role => role.role) : [];
    const superUser = userOrgRoles.includes('super');

    const { toplevelOverride = '', secondlevelOverride = '' } = this.state;
    const toplevel = toplevelOverride || this.props.toplevel;
    const secondlevel = secondlevelOverride || this.props.secondlevel;

    const leftStyles = { width: '72px' };
    const rightStyles = { overflowY: 'auto' };

    if (menuClosed) {
      leftStyles.width = 'calc(100%)';
      rightStyles.width = '0px';
    }


    const { menuItems = [] } = config;
    const menuItem = _.find(menuItems, { type: toplevel.toLowerCase() }) || {};
    const children = menuItem.children || [];
    const cleanChildren = _.filter(children, (c) => {
      c.toplevel = menuItem.type;

      if (superUser || _.isUndefined(c.roles) || _.isEmpty(c.roles)) {
        return true;
      }

      if (c.roles.some(role => userOrgRoles.includes(role))) {
        return true;
      }

      return false;
    });

    /* eslint-disable jsx-a11y/anchor-is-valid */
    return (
      <div className='sidebar-wrapper fill d-flex h-100' data-menu-closed={menuClosed}>
        <div className='row w-100' style={{ margin: 0 }}>
          <div className='sidebar-left-wrapper' style={{ ...leftStyles }}>
            {_.map(menuItems, m => (
              <div
                key={m.type}
                className={`top-level-menu-item${m.type === toplevel.toLowerCase() ? ' active' : ''}`}
                role='button'
                tabIndex={-1}
                onClick={this.selectTopLevel.bind(this, m.type)}
              >
                <span className='icon'><i className={m.icon} /></span>
                {menuClosed && <span className='title'>{m.title}</span>}
              </div>
            ))}
          </div>
          <div className='sidebar-right-wrapper h-100 fill' style={{ ...rightStyles }}>
            <div>
              {_.map(cleanChildren, c => (
                <Link
                  key={c.type}
                  to={{ type: 'PAGE', payload: { ...payload, toplevel: c.toplevel, secondlevel: c.type } }}
                >
                  <div
                    className={`second-level-menu-item${c.type === secondlevel.toLowerCase() ? ' active' : ''}`}
                  >
                    <span className='title'>{c.title}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
    /* eslint-enable jsx-a11y/anchor-is-valid */
  }
}

SidebarView.propTypes = {
  payload: PropTypes.shape({}),
  menuClosed: PropTypes.bool,
  toggleMenu: PropTypes.func.isRequired,
  toplevel: PropTypes.string,
  secondlevel: PropTypes.string,
};

SidebarView.defaultProps = {
  payload: {},
  menuClosed: false,
  toplevel: '',
  secondlevel: '',
};

export default SidebarView;



// WEBPACK FOOTER //
// ./src/views/SidebarView.js